export const sendPixelEvent = async (apiUrl, data) => {
  if (window.location.hostname === "localhost") {
    return;
  }

  try {
    const response = await fetch(apiUrl + "/pixels/facebook", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();
    console.log("Evento enviado:", result);
  } catch (error) {
    console.error("Erro ao enviar evento:", error);
  }
};
